import moment from 'moment'

export function formatPrice(amount) {
  return `${amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}:-`
}

export function rando(arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export function getCurrentMonth() {
  const d = new Date()

  return monthNames[d.getMonth()]
}

export function getWeeks(date) {
  let _m = moment(date)
  const DAYS = _m.daysInMonth()
  const weeks = {}

  for(let i=0; i<DAYS; i++) {
    const weekNumber = _m.week()
    const day = _m.format('DD')
    const date = _m.format('YYYY-MM-DD')
    const weekDay = _m.format('ddd')
    const dayObject = {
      weekDay,
      day,
      date
    }

    if(!weeks[weekNumber]) weeks[weekNumber] = []

    weeks[weekNumber].push(dayObject)

    _m = _m.clone().add(1, 'd')
  }

  return weeks
}

export const setDate = (d = new Date()) => {
  d.setDate(1)
  return d
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js